var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8Django(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4H25V8H21zM25 22.754c0 1.35-.317 5.799-4.242 7.149L17 28c2.806-1.224 4-3.2 4-5.246C21 19.926 21 11 21 11l4 .002C25 11.002 25 19.715 25 22.754zM14 4v6.302c-.469-.191-1.48-.228-1.978-.228C8.273 10.074 5 12.011 5 17c0 5.969 4.504 6.997 7.65 6.997 1.242 0 4-.122 5.35-.513V4H14zM12.609 20.666C10.84 20.666 9 19.863 9 17s1.84-3.469 3.609-3.469c.432 0 .918.081 1.391.189v6.757C13.528 20.584 13.042 20.666 12.609 20.666z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Django);
export default __webpack_public_path__ + "static/media/icons8-django.3f59a22e8fc4c9a471b0b810b9b6c739.svg";
export { ForwardRef as ReactComponent };